import { useEffect } from 'react';
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom';
import WOW from 'wowjs';
import AR_image from '../../Assets/images/DesignFrame.png'
import En_image from '../../Assets/images/EnDesignFrame.png'

export default function WhoUs({ dir }) {
    const DesignImg = dir === 'rtl' ? AR_image :En_image;
    
    useEffect(() => {
        new WOW.WOW({
            live: true,
            mobile: false
        }).init();
    }, []);

    return <>
            <div className="row justify-content-evenly">
                <div className="col-md-11">
                    <div className="row justify-content-between align-items-center" >
                        <div className="col-lg-6">
                            <div className="col-md-11 headlineContainer wow fadeInLeft"  >
                                <h2 className='Title px-2 my-4'>
                                    <div className='indicator'></div>
                                    <Trans i18nKey="WhousTitle">  شركة قانونية برؤية حديثة وخبرة عميقة
                                    </Trans>
                                </h2>
                            </div>
                            <h4 className='subtitle wow fadeIn px-2 justify-margin' data-wow-delay=".5s" style={{ fontFamily: 'var(--font2)' }}><Trans i18nKey="WhousSubtitle">تأسست شركة عبدالله الجاسر للمحاماة والاستشارات القانونية بهدف تقديم حلول قانونية متكاملة ومتوافقة مع أحدث الأنظمة والتشريعات. نعتمد على فريق من الخبراء القانونيين المتخصصين، ونسعى لتقديم خدماتنا بأسلوب احترافي يضمن حماية حقوق عملائنا وتحقيق أهدافهم القانونية بأفضل الطرق.</Trans></h4>
                            <Link to="/info/AboutUs" className='justify-margin'>
                                <button className='HeroBtn p-3 px-4 wow fadeInUp my-4 mx-2' data-wow-delay="1s">
                                    <Trans i18nKey="whousBtn">   من نحن </Trans>
                                </button>
                            </Link>
                        </div>
                        <div className="col-lg-5 Design_Logo  wow fadeInLeft" >
                            <img src={DesignImg} alt="brand logo" className='w-100' loading="lazy"/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    
}
